module.exports = "/images/flag-de.svg?5220274ec034cd40865bb0b875a45282";